import React from 'react';
import './SaleRibbon.css';

function SaleRibbon() {
    return (
        <div
            className={`ribbon`}
        >
            <span>Sale</span>
        </div>
    );
}

export default SaleRibbon;
